/**
 * @generated SignedSource<<7671a1d81f4090bf99606a23346d91bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemoveProfanityMutation$variables = {
  productIds: ReadonlyArray<number>;
  profanityRuleId: string;
};
export type productSidePanelContent_RemoveProfanityMutation$data = {
  readonly removeProductsFromProfanityRule: {
    readonly result: boolean;
  } | null;
};
export type productSidePanelContent_RemoveProfanityMutation = {
  response: productSidePanelContent_RemoveProfanityMutation$data;
  variables: productSidePanelContent_RemoveProfanityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profanityRuleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "profanityRuleId",
        "variableName": "profanityRuleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "removeProductsFromProfanityRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemoveProfanityMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_RemoveProfanityMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0e8a1f5919f20e66f2cef0ed025df777",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemoveProfanityMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemoveProfanityMutation(\n  $profanityRuleId: ID!\n  $productIds: [Long!]!\n) {\n  removeProductsFromProfanityRule(profanityRuleId: $profanityRuleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "a66b2a010d105fe1849a5a713881d39d";

export default node;
